export default __webpack_public_path__ + "static/media/content-lecture-bg.19b1cb0d.png";